/**
 * @description：获取异步函数的值
 *
 */

function getAsyncResult(promise, timeout = 5000) {
    const timer = new Promise((resolve, reject) => {
        const timeoutFn = () => {
            reject({
                code: -1,
                msg: '服务超时，请稍后重试~'
            });
        };
        setTimeout(timeoutFn, timeout);
    });

    // 竞赛
    return Promise.race([
        promise,
        timer,
    ]);
}

export default getAsyncResult;



// WEBPACK FOOTER //
// ./src/lib/promise/getAsyncResult.js